{% block swag_migration_history_detail_data %}
    <div class="swag-migration-history-detail-data">
        <div v-if="!isLoading">

            {% block swag_migration_history_detail_data_grid %}
                <sw-data-grid v-if="migrationData.length > 0"
                              identifier="swag-migration-history-detail-data"
                              :data-source="migrationData"
                              :columns="columns"
                              :show-selection="false"
                              :show-settings="false"
                              :allow-column-edit="false"
                              :show-actions="false"
                              :sort-by="sortBy"
                              :sort-direction="sortDirection"
                              @column-sort="onSortColumn">

                    {% block swag_migration_history_detail_data_grid_name %}
                        <template #column-name="{ item }">
                            {{ item.name }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_detail_data_grid_count %}
                        <template #column-count="{ item }">
                            {{ item.total }}
                        </template>
                    {% endblock %}

                    {% block swag_migration_history_detail_data_grid_pagination %}
                        <template #pagination>
                            <sw-pagination :page="page"
                                           :limit="limit"
                                           :total="total"
                                           :steps="[5,10]"
                                           :total-visible="7"
                                           @page-change="onPageChange" />
                        </template>
                    {% endblock %}
                </sw-data-grid>
            {% endblock %}

            {% block swag_migration_history_detail_data_noData %}
                <p v-if="migrationData.length === 0"
                   class="swag-migration-history-detail-data__no-data">
                    {{ $tc('swag-migration.history.detailPage.noProgressData') }}
                </p>
            {% endblock %}
        </div>

        {% block swag_migration_history_detail_data_noError__loader %}
            <div v-if="isLoading"
                 class="swag-migration-history-detail-data__loading-placeholder"></div>
            <mt-loader v-if="isLoading" />
        {% endblock %}
    </div>
{% endblock %}
